import React, {FC} from 'react';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {DatePicker} from '@mui/x-date-pickers/DatePicker';
import dayjs, {Dayjs} from 'dayjs';
import {SxProps} from '@mui/material';

interface DateSelectorProps {
	label: string;
	value: Dayjs;
	onChange: (date: Dayjs) => void;
	disableDayFunction?: (date: Dayjs) => boolean;
	dateFormat?: string;
	sx?: SxProps;
	disabled?: boolean;
}

const DateSelector: FC<DateSelectorProps> = ({label, value, onChange, disableDayFunction, dateFormat, sx, disabled}) => {
	const handleChange = (date: Dayjs | null) => {
		if (!date) return;
		onChange(date);
	};

	return (
		<LocalizationProvider dateAdapter={AdapterDayjs}>
			<DatePicker
				disableFuture
				label={label}
				shouldDisableDate={(date) => {
					if (disableDayFunction) {
						return disableDayFunction(date);
					}
					return false;
				}}
				onChange={handleChange}
				value={dayjs(value)}
				format={dateFormat || 'DD/MM/YYYY'}
				slotProps={{
					textField: {
						size: 'small',
						inputProps: {
							sx: {
								fontSize: 'clamp(12px, 1.5vw, 14px)',
								paddingTop: '10px',
								paddingBottom: '10px',
							},
						},
					},
				}}
				sx={sx}
				disabled={disabled ?? false}
			/>
		</LocalizationProvider>
	);
};

export default DateSelector;
